

import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"
const REPO_URL_PREFIX = '/role'
const REPO_URL = {
    getList: `${REPO_URL_PREFIX}/paginated`,
    getRoleById: `${REPO_URL_PREFIX}/id`,
    createRole: `${REPO_URL_PREFIX}/create`,
    updateRole: `${REPO_URL_PREFIX}/update`,
    hasUserRole: `${REPO_URL_PREFIX}/has-user`,
    getPrivilegeList: `${REPO_URL_PREFIX}/view-all-privilege-as-tree`
}

const useRoleRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getRoleList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getRoleById = async (payload) => {
        return await executeApi(REPO_URL.getRoleById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const createRole = async (payload) => {
        return await executeApi(REPO_URL.createRole, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const updateRole = async (payload) => {
        return await executeApi(REPO_URL.updateRole, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getPrivilegeList = async (payload) => {
        return await executeApi(REPO_URL.getPrivilegeList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const deleteRole = async (payload) => {
        return await executeApi(REPO_URL.delete, BASE_API_CONSTANT.METHOD.POST, payload)
    }
    
     const hasUserRole = async (payload) => {
        return await executeApi(REPO_URL.hasUserRole, BASE_API_CONSTANT.METHOD.POST, payload)
    }
    

    return {
        isLoading,
        data,
        error,
        getRoleList,
        getRoleById,
        createRole,
        updateRole,
        getPrivilegeList,
        deleteRole,
        hasUserRole
    }
}

export default useRoleRepo
